import logo from "./logo.svg";
import "./App.css";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <p>This is PerfAnalytics test site!</p>
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Check your performance metric values from{"  "}
          <a
            className="App-link"
            href="https://hasantezcan.github.io/PerfAnalytics-Dashboard/"
            target="_blank"
            rel="noopener noreferrer"
          >
            here!
          </a>
        </p>
        <p>Also you can see your preformance metrics from browser console.</p>
      </header>
    </div>
  );
}

export default App;
